import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Overflowable = styled.span`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ lines }) => lines};
  display: -webkit-box;
  overflow: hidden;
`;

const Expand = styled.span`
  align-self: flex-start;
  color: var(--primary);
  cursor: pointer;
  font-weight: var(--bold);

  :hover,
  :focus {
    color: var(--primary-dark);
  }

  :focus {
    outline: 1px solid var(--primary);
    outline-offset: 1px;
  }
`;

function ExpandableText({ children, className, lines = 1 }) {
  const ref = useRef();
  const [expandable, setExpandable] = useState(false);
  const [expanded, setExpanded] = useState();

  useEffect(() => {
    const { current: $text } = ref;

    // Check if truncated by checking if scroll height is greater than visible
    const truncated = $text.scrollHeight > $text.clientHeight;

    setExpandable(truncated);
    setExpanded(!truncated);
  }, [children]);

  const toggle = () => {
    setExpanded(current => !current);
  };

  return (
    <Wrapper
      aria-expanded={expanded}
      aria-label="Expandable text"
      className={className}
    >
      {
        // Show original text if already expanded or not overflowing
        expanded && children
      }

      {
        // Show truncated text if not already expanded
        !expanded && (
          <Overflowable lines={lines} ref={ref}>
            {children}
          </Overflowable>
        )
      }

      {
        // Only show action if expandable
        expandable && (
          <Expand onClick={toggle} role="button">
            Show {expanded ? 'less' : 'more'}
          </Expand>
        )
      }
    </Wrapper>
  );
}

ExpandableText.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  lines: PropTypes.number,
};

export default styled(ExpandableText)``;
